/* eslint-disable max-len */
/*
 *  PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2025 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/*
 * A React component for ExpandIcon
 *
 * @author Anuja Gaikwad
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const ExpandIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 16 9"
    fontSize="inherit"
  >
    <path
      d="M8.67729 8.73574L8.67727 8.73572C8.68724 8.72656 8.69718 8.71703 8.70711 8.70711L15.7071 1.70711C16.0976 1.31658 16.0976 0.683417 15.7071 0.292893C15.3166 -0.0976305 14.6834 -0.0976305 14.2929 0.292893L8 6.58579L1.70711 0.292893C1.31658 -0.0976305 0.683418 -0.0976305 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L7.29289 8.70711C7.67363 9.08784 8.28499 9.09739 8.67729 8.73574Z"
      fill="#171717"
    />
  </SvgIcon>
);

export default ExpandIcon;
